import React from 'react';
import { NavSection, NavItem } from './types';
import { AppSidebarItem } from './app-sidebar-item';
import { isRouteActive } from './utils/route-matcher';
import { ANIMATION_DURATION } from './constants';

interface AppSidebarSectionProps {
  section?: NavSection;
  items?: NavItem[];
  label?: string;
  isCollapsed: boolean;
  pathname: string;
  showBorder?: boolean;
  className?: string;
  paddingTop?: string | { collapsed: string; expanded: string };
}

export function AppSidebarSection({
  section,
  items: itemsProp,
  label: labelProp,
  isCollapsed,
  pathname,
  showBorder = false,
  className,
  paddingTop,
}: AppSidebarSectionProps) {
  // Use section if provided, otherwise use items/label props
  const items = section?.items ?? itemsProp ?? [];
  const label = section?.label ?? labelProp;

  const containerStyle = paddingTop
    ? typeof paddingTop === 'string'
      ? { paddingTop }
      : {
          paddingTop: isCollapsed ? paddingTop.collapsed : paddingTop.expanded,
          transition: `padding-top ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
        }
    : undefined;

  const sectionClass = [
    'sidebar-section',
    showBorder && 'sidebar-section--bordered',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const titleClass = [
    'sidebar-section__title',
    isCollapsed && 'sidebar-section__title--collapsed',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={sectionClass} style={containerStyle} id={section?.id}>
      {label && <div className={titleClass}>{label}</div>}
      <div className="sidebar-section__items">
        {items.map((item) => {
          const isActive = isRouteActive(
            pathname,
            item.href,
            item.activeMatcher
          );
          return (
            <AppSidebarItem
              key={item.href}
              item={item}
              isActive={isActive}
              isCollapsed={isCollapsed}
            />
          );
        })}
      </div>
    </div>
  );
}
